import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseSiteService, CmsService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import { LoactionStripService } from 'src/app/shared/modules/location-strip/loaction-strip.service';
import { RequestSupportComponent } from 'src/app/shared/modules/request-support/request-support.component';
import { SharedService } from 'src/app/shared/services/shared.service';
import { ReturnService } from '../return.service';

@Component({
    selector: 'app-my-account',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './my-account.component.html',
    styleUrls: ['./my-account.component.scss'],
    standalone: false
})
export class MyAccountComponent implements OnInit {

  cmsContent: any;
  userInfo: any;

  constructor(private readonly cmsData: CmsService,
    private readonly cd: ChangeDetectorRef,
    private readonly service: ReturnService,
    private readonly modalService: NgbModal,
    private readonly baseSiteService: BaseSiteService,
    private readonly locService: LoactionStripService,
    private readonly customProfService: CustomProfileAndPreferencesService,
    private readonly sharedService: SharedService) { }

  baseSiteId: string;
  locationData;
  userDetails$: any;
  locSub: Subscription;
  accountDetails;
  fullName;
  ngOnInit(): void {
    let userId = this.sharedService.getLocalStorage('userId');
    let b2bUnitId = this.sharedService.getLocalStorage('accountId');
    this.customProfService.getUserAccountDetailsDataFromDb(userId, b2bUnitId);

    this.customProfService.getUserDataFromDb(null);
    this.cmsData.getComponentData("NoCustomRepComponent").subscribe(res => {
      let needAssistanceContent: any = JSON.parse(JSON.stringify(res));
      this.cmsContent = needAssistanceContent.content;
      this.cd.detectChanges();
    });
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    this.locSub = this.locService.emitSelectedLocs$.subscribe(locsData => {
      this.locationData = !!locsData ? locsData[0] : JSON.parse(sessionStorage.getItem('defaultLocation'))[0];
    });
    this.customProfService.userAccountDetails.pipe(take(2)).subscribe(res => {
      if (res && res !== '') {
        this.accountDetails = res.res.billingAddress;
      }
    });
    this.customProfService.userData.pipe(map((({res}) => res) as any),take(1)).subscribe(res => {
      if (res) {
        this.fullName = res.firstName + ' ' + res.lastName
        this.cd.detectChanges();
      }
    });
  }
  openModal() {
    this.modalService.open(RequestSupportComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: `${this.baseSiteId}`
    });
  }

  ngOnDestroy() {
    this.locSub.unsubscribe();
  }

}
